export default __webpack_public_path__ + "static/media/placeholder_portfolio04-fr-mobile.d09c36b8.png";